import type { ThemeDefinition } from "vuetify"
import { createVuetify } from "vuetify"
import { fr } from "vuetify/locale"

import "@mdi/font/css/materialdesignicons.css"

import * as labsComponents from "vuetify/labs/components"
import * as components from "vuetify/components"
import * as directives from "vuetify/directives"

const myCustomLightTheme: ThemeDefinition = {
    dark: false,
    colors: {
        background: "#F4F6F8",
        surface: "#FFFFFF",
        light: "#F1F5F9",
        dark: "#0F172A",

        primary: "#1E293B",
        secondary: "#64748B",

        danger: "#EF4444",
        error: "#EF4444",
        info: "#3B82F6",
        success: "#10B981",
        warning: "#F59E0B",
    },
}

export default defineNuxtPlugin((nuxt) => {
    const vuetify = createVuetify({
        ssr: true,
        components: {
            ...components,
            ...labsComponents,
        },
        directives,
        theme: {
            defaultTheme: "myCustomLightTheme",
            themes: {
                myCustomLightTheme,
            },
        },
        icons: {
            defaultSet: "mdi",
        },
        locale: {
            locale: "fr",
            fallback: "en",
            messages: { fr },
        },
    })
    nuxt.vueApp.use(vuetify)
})
